export default "__VITE_ASSET__DpHU2RVf__"